/* Uses this theme's cart drawer public methods and Shopify's native product form fallback. */
(() => {
  'use strict';
  if (window.tpHomeLoaded) return;
  window.tpHomeLoaded = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  function init(root = document) {
    root.querySelectorAll('[data-tp-product], [data-tp-hero], [data-tp-transition], [data-tp-delivery], [data-tp-reviews]').forEach(el => {
      if (controllers.has(el)) return;
      const abort = new AbortController();
      const cleanups = [];
      const on = (node, event, fn, options = {}) => node.addEventListener(event, fn, {...options, signal: abort.signal});
      controllers.set(el, () => { abort.abort(); cleanups.forEach(fn => fn()); });
      if (el.matches('[data-tp-delivery]')) {
        const now = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Istanbul', year:'numeric', month:'2-digit', day:'2-digit'}).formatToParts(new Date());
        const part = type => Number(now.find(p => p.type === type).value);
        const base = new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
        const workday = days => { const d = new Date(base); for (let i = 0; i < days;) { d.setUTCDate(d.getUTCDate() + 1); if (![0,6].includes(d.getUTCDay())) i++; } return d; };
        const fmt = new Intl.DateTimeFormat('tr-TR', {day:'numeric', month:'long', timeZone:'UTC'});
        const range = (min,max) => min === max ? fmt.format(workday(min)) : fmt.format(workday(min)) + ' – ' + fmt.format(workday(max));
        const prep = [Number(el.dataset.prepMin),Number(el.dataset.prepMax)].sort((a,b)=>a-b);
        const ship = [Number(el.dataset.shipMin),Number(el.dataset.shipMax)].sort((a,b)=>a-b);
        el.querySelector('[data-tp-dispatch]').textContent = range(...prep);
        const arrival = range(prep[0]+ship[0],prep[1]+ship[1]);
        el.querySelector('[data-tp-arrival]').textContent = arrival;
        el.querySelector('[data-tp-delivered]').textContent = arrival;
      }
      if (el.matches('[data-tp-reviews]')) {
        const list = el.querySelector('.tp-reviews__list');
        const cards = [...list.children];
        const prev = el.querySelector('[data-tp-prev]'), next = el.querySelector('[data-tp-next]');
        const dots = el.querySelector('.tp-review-dots');
        let current = 0, startX = 0, startY = 0;
        el.classList.add('is-carousel');
        const buttons = cards.map((card,i) => {
          const button = document.createElement('button');
          button.type = 'button'; button.setAttribute('aria-label', (i + 1) + '. yorumu göster');
          button.innerHTML = '<span></span>'; dots.append(button);
          on(button,'click',()=>show(i));return button;
        });
        function show(index) {
          current = (index + cards.length) % cards.length;
          cards.forEach((card,i)=>{
            const active = i === current;
            card.classList.toggle('is-active',active);
            card.classList.toggle('is-prev',cards.length > 2 && i === (current - 1 + cards.length) % cards.length);
            card.classList.toggle('is-next',cards.length > 1 && i === (current + 1) % cards.length);
            card.setAttribute('aria-hidden',String(!active));
            buttons[i].setAttribute('aria-pressed',String(active));
          });
          el.querySelector('[data-tp-review-count]').textContent = (current+1) + ' / ' + cards.length;
        }
        prev.hidden = next.hidden = dots.hidden = cards.length < 2;
        on(prev,'click',()=>show(current-1));on(next,'click',()=>show(current+1));
        on(el,'keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();show(current+(e.key==='ArrowRight'?1:-1));}});
        on(list,'touchstart',e=>{startX=e.changedTouches[0].clientX;startY=e.changedTouches[0].clientY;},{passive:true});
        on(list,'touchend',e=>{const dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy))show(current+(dx<0?1:-1));},{passive:true});
        on(document,'shopify:block:select',e=>{const i=cards.findIndex(card=>card===e.target || card.contains(e.target));if(i>=0)show(i);});
        cleanups.push(()=>dots.replaceChildren());show(0);
      }
      if (el.matches('[data-tp-product]')) {
        const form = el.querySelector('form');
        const variants = JSON.parse(el.querySelector('[data-tp-variants]').textContent);
        const select = el.querySelector('[data-tp-variant]');
        const add = form.querySelector('[name="add"]');
        const buy = form.querySelector('[data-tp-buy]');
        const status = form.querySelector('.tp-form-status');
        let busy = false;
        const selected = () => variants.find(v => String(v.id) === select.value);
        const image = (src, alt) => {
          const img = el.querySelector('.tp-gallery__main');
          if (!img || !src) return;
          img.removeAttribute('srcset'); img.src = src; img.alt = alt || '';
          el.querySelectorAll('[data-tp-image]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.tpImage === src)));
        };
        const update = () => {
          const v = selected();
          const q = Number(form.querySelector('[name="quantity"]:checked').value);
          add.disabled = buy.disabled = busy || !v?.available;
          if (!v) return;
          el.querySelector('[data-tp-price]').innerHTML = v.prices[0];
          const compare = el.querySelector('[data-tp-compare]');
          compare.innerHTML = v.compare[0]; compare.hidden = !v.onSale;
          el.querySelector('[data-tp-total]').innerHTML = v.prices[q - 1];
          el.querySelectorAll('[data-tp-quantity-price]').forEach(n => n.innerHTML = v.prices[Number(n.dataset.tpQuantityPrice) - 1]);
          el.querySelectorAll('[data-tp-quantity-compare]').forEach(n => { n.innerHTML = v.compare[Number(n.dataset.tpQuantityCompare) - 1]; n.hidden = !v.onSale; });
          el.querySelector('[data-tp-stock]').textContent = v.available ? 'Siparişe açık' : 'Tükendi';
        };
        on(select, 'change', () => {update(); const v = selected(); if (v) image(v.image, v.alt); status.textContent = '';});
        form.querySelectorAll('[name="quantity"]').forEach(r => on(r, 'change', update));
        el.querySelectorAll('[data-tp-image]').forEach(b => on(b, 'click', () => image(b.dataset.tpImage, b.dataset.alt)));
        on(form, 'submit', async event => {
          event.preventDefault();
          if (busy || !selected()?.available) return;
          const checkout = event.submitter === buy;
          busy = true; update(); form.setAttribute('aria-busy', 'true');
          status.textContent = 'Ürün sepete ekleniyor…';
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const data = new FormData(form);
          data.delete('checkout'); data.delete('add');
          if (cart?.getSectionsToRender && !checkout) {
            data.set('sections', cart.getSectionsToRender().map(s => s.id).join(','));
            data.set('sections_url', location.pathname);
            cart.setActiveElement?.(event.submitter || add);
          }
          try {
            const response = await fetch(el.dataset.addUrl + (el.dataset.addUrl.endsWith('.js') ? '' : '.js'), {
              method: 'POST', headers: {'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, body:data
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'Ürün eklenemedi. Lütfen seçimi ve stok durumunu kontrol edin.');
            status.textContent = 'Ürün sepetinize eklendi.';
            if (checkout) { location.assign(el.dataset.checkoutUrl); return; }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'tp-home'});
            if (cart?.renderContents && result.sections && Object.values(result.sections).every(Boolean)) {
              try { cart.classList.remove('is-empty'); cart.renderContents(result); }
              catch { location.assign(el.dataset.cartUrl); }
            } else { location.assign(el.dataset.cartUrl); }
          } catch (error) {
            status.textContent = error instanceof TypeError ? 'Bağlantı kesildi. Yeniden denemeden önce sepetinizi kontrol edin.' : error.message;
          } finally { busy = false; form.removeAttribute('aria-busy'); update(); }
        });
        update();
      }
      if (el.matches('[data-tp-hero]')) {
        const video = el.querySelector('video');
        if (!video) return;
        const mobile = matchMedia('(max-width: 749px)');
        let manuallyPaused = false, inView = true;
        const play = async () => { try { await video.play(); } catch { /* Native poster remains; tapping retries playback. */ } };
        const load = () => {
          const sources = [...video.querySelectorAll('source')];
          const desktop = sources.find(s=>s.dataset.desktop)?.dataset.desktop;
          const src = mobile.matches ? (sources.find(s=>s.dataset.mobile)?.dataset.mobile || desktop) : desktop;
          video.poster = (mobile.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster) || '';
          if (src && video.getAttribute('src') !== src) {video.pause();video.src=src;video.preload='metadata';video.load();}
          if (!reduced.matches && !manuallyPaused && inView) play();
        };
        const toggle = () => { manuallyPaused = !video.paused; if(video.paused)play();else video.pause(); };
        on(video,'click',toggle);on(video,'keydown',e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();toggle();}});
        on(mobile,'change',load);
        on(reduced,'change',()=>{if(reduced.matches)video.pause();else if(!manuallyPaused&&inView)play();});
        on(document,'visibilitychange',()=>{if(document.hidden)video.pause();else if(inView&&!reduced.matches&&!manuallyPaused)play();});
        load();
        const io = new IntersectionObserver(entries=>entries.forEach(e=>{inView=e.isIntersecting;if(!inView)video.pause();else if(!reduced.matches&&!manuallyPaused&&!document.hidden)play();}),{threshold:.05});
        io.observe(el);cleanups.push(()=>{io.disconnect();video.pause();video.removeAttribute('src');video.load();});
      }
      if (el.matches('[data-tp-transition]') && el.querySelector('.tp-story__night')) {
        let visible = false, frame = 0;
        const update = () => {
          frame = 0;
          if (reduced.matches) {el.style.setProperty('--tp-night',0);return;}
          const rect = el.getBoundingClientRect();
          const start = innerHeight * 0.95;
const distance = innerHeight * 0.9 + rect.height;

const progress = Math.max(
  0,
  Math.min(1, (start - rect.top) / distance)
);
          el.style.setProperty('--tp-night',progress.toFixed(3));
        };
        const request = () => {if (visible && !frame) frame = requestAnimationFrame(update);};
        const io = new IntersectionObserver(entries => entries.forEach(e => {visible = e.isIntersecting;if (visible) request();}));
        io.observe(el);on(window,'scroll',request,{passive:true});on(window,'resize',request,{passive:true});on(reduced,'change',update);
        cleanups.push(() => {io.disconnect();cancelAnimationFrame(frame);});update();
      }
    });
  }
  // The legacy close button uses the submenu handler; route it through the main drawer API so body scroll is released.
  document.addEventListener('click', event => {
    const button = event.target.closest('.menu-drawer__close-btn');
    const drawer = button?.closest('header-drawer');
    if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;
    event.preventDefault(); event.stopImmediatePropagation();
    const summary = drawer.querySelector('summary');
    summary.setAttribute('aria-expanded', 'false');
    drawer.closeMenuDrawer(event, summary);
  }, true);
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('#Details-menu-drawer-container')) event.target.querySelector('summary')?.setAttribute('aria-expanded', String(event.target.open));
  }, true);
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    controllers.forEach((cleanup,el) => {if (e.target.contains(el)) {cleanup();controllers.delete(el);}});
  });
  document.addEventListener('shopify:block:select', e => {const details=e.target.closest('details');if(details) details.open=true;});
})();
